import 'vanilla-cookieconsent/dist/cookieconsent.css'
import './scss/main.scss'
import './js/instantPage'
// import '@builder.io/partytown'
import Menu from './js/Menu'
import Search from './js/Search'
import LazyLoadImages from './js/LazyLoadImages'
import initCookieConsent from './js/CookieConsent'

new Menu('#menu-open', '#menu-close', '.menu-wrapper', '#menu-overlay')
new Search()
new LazyLoadImages('*[data-srcset]', 'data-srcset', 'srcset')
new LazyLoadImages('*[data-src]')
initCookieConsent()
